import { render } from "./SupplierDueList.vue?vue&type=template&id=1884a3c9"
import script from "./SupplierDueList.vue?vue&type=script&lang=js"
export * from "./SupplierDueList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__